<goab-tabs (onChange)="onTabChange($event)" [initialTab]="1">
  <goab-tab heading="To-do reports" data-testid="todo-tab"></goab-tab>
  <goab-tab heading="Completed reports" data-testid="completed-tab"></goab-tab>
</goab-tabs>
